/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 12:02
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class ServerErrorLOFactory extends BasicLogObjectFactory {
    public static CONNECT_FAILED: number = 13001;
    public static ROOMLIST_FAILED: number = 13002;
    public static JOINROOM_FAILED: number = 13003;
    public static LOGIN_RESPONCE_FAILED: number = 13004;
    public static CONNECTION_LOST: number = 13005;
    public static CONNECTION_KILLED: number = 13006;

    private static SERVER_ERROR: number = 13;

    private static PARAM_BLUEBOX: string = "bluebox";

    private _zone: string;
    private _bluebox: number;

    constructor(subErrorId: number, zone: string, bluebox: number) {
        super();

        this._subErrorId = subErrorId;
        this._zone = zone;
        this._bluebox = bluebox;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Update with customData
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, ServerErrorLOFactory.SERVER_ERROR.toString());
        lo.logData.set(ExternalLoggingConstants.PARAM_ZONE, this._zone);
        lo.logData.set(ServerErrorLOFactory.PARAM_BLUEBOX, this._bluebox.toString());
        return lo;
    }
}
